/**
 * Transition CSS Class Constants
 * Centralized definitions for CSS classes used in view transitions and animations
 * 
 * @typedef {Object} TransitionClasses
 * @property {string} FADE_IN - CSS class for fade-in animation
 * @property {string} FADE_OUT - CSS class for fade-out animation
 * @property {string} PRODUCT_DETAIL_FADE_FIX - CSS class for product detail view transitions
 */

export const TRANSITION_CLASSES = {
    FADE_IN: 'fade-in',
    FADE_OUT: 'fade-out',
    PRODUCT_DETAIL_FADE_FIX: 'product-detail-fade-fix'
};
